import useForgeRock from "hooks/useForgeRock";
import { useState, useEffect } from "react";
import { companyDetailApi } from "services/apis";
import { appInsights } from "../ApplicationInsights";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

export type companyDetail = {
  companyName: string;
};

export type CompanyResponse = {
  resultCode: number;
  response: companyDetail;
  errorList?: { errorMessage: string; errorCode: number }[];
};

const useGetCompany = () => {
  const { APICall } = useForgeRock();
  const [company, setCompany] = useState<companyDetail>({
    companyName: "",
  });
  useEffect(() => {
    const getCompanyData = async () => {
      try {
        const result: CompanyResponse = await APICall({
          ...companyDetailApi(),
        });
        if (result.resultCode === 0 && result.response) {
          return setCompany(result.response);
        }
        throw new Error("Failed to retrieve user details");
      } catch (error) {
        appInsights.trackException({
          error: error as Error,
          severityLevel: SeverityLevel.Error,
        });
        setCompany({ companyName: "" });
      }
    };
    getCompanyData();
  }, []);

  return { company };
};

export default useGetCompany;
